import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { Typography } from 'app/shared/components/atoms';
import { MappingsProps } from 'app/fan/components/templates/EventPage/components/EventCharacteristicsList/utils';
import { ReactComponent as Identification } from 'icons/id.svg';

export function useAgeRestrictionMappings({ formatMessage }: MappingsProps) {
  const { colors } = useCurrentTheme();
  const intlPrefix = 'event.eventCharacteristicsList.ageRestrictions';
  const id = 'age_restrictions';

  const details = (
    <Typography color={colors.primary.white.base}>
      {formatMessage({ id: `${intlPrefix}.details` })}
    </Typography>
  );

  return {
    over25Only: {
      id,
      title: formatMessage({ id: `${intlPrefix}.over25Only` }),
      icon: Identification,
      details,
    },
    over23Only: {
      id,
      title: formatMessage({ id: `${intlPrefix}.over23Only` }),
      icon: Identification,
      details,
    },
    over21Only: {
      id,
      title: formatMessage({ id: `${intlPrefix}.over21Only` }),
      icon: Identification,
      details,
    },
    over19Only: {
      id,
      title: formatMessage({ id: `${intlPrefix}.over19Only` }),
      icon: Identification,
      details,
    },
    over18Only: {
      id,
      title: formatMessage({ id: `${intlPrefix}.over18Only` }),
      icon: Identification,
      details,
    },
  };
}
